import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import MemberResults from 'src/components/member/MemberListResults';
import { getMembers } from 'src/api/member';
import { CONSTANTS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { commonReducerAction } from 'src/redux/reducers/common';

const Member = () => {
  const dispatch = useDispatch();
  const { startLoading, stopLoading } = loaderReducerAction;
  const { logoutUser } = commonReducerAction;
  const { user } = useSelector((state) => state.common);
  const [members, setMembers] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(startLoading());
    getMembers(user)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) setMembers(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => dispatch(stopLoading()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>Message | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ pt: 3 }}>
            <MemberResults
              members={members}
              onClickRow={(user) => {
                navigate(
                  CONSTANTS.ROUTES.PRIVATE_ROUTES.MESSAGE + '/' + user._id
                );
              }}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Member;
